<template>
  <div class="font-sans antialiased px-4 flex sticky top-0 z-10 bg-white">
    <nav
      class="flex items-end flex-wrap mt-4 mb-0 lg:mb-0 container lg:max-w-7xl"
    >
      <div class="flex items-center lg:max-w-max">
        <button
          @click="toggle"
          class="flex items-center px-3 py-2 border rounded text-teal-lighter lg:hidden"
        >
          <Hamburger />
        </button>
        <!-- Menu icon for mobile-->
        <div class="flex">
          <img
            class="max-w-[150px] lg:max-w-[300px] cursor-pointer"
            :src="require('../assets/logo.png')"
            height="40"
            @click="$router.push('/')"
            style="cursor: pointer; padding-right:5px;"
          />
        </div>
      </div>
      <!-- Menu Links -->
      <div
        :class="open ? 'block' : 'hidden'"
        class="w-full flex-grow lg:flex lg:items-center lg:w-auto lg:ml-20"
      >
        <ul class="text-sm lg:flex-grow pl-0">
          <li @click="closeMenu">
            <router-link
              v-for="(navItem, n) in navigation"
              :key="n"
              :to="navItem.route"
              tag="li"
              active-class="!text-gray"
              class="no-underline block mt-4 lg:inline-block lg:mt-0 mr-8 text-base font-semibold cursor-pointer"
            >
              {{ navItem.title }}
            </router-link>
          </li>
        </ul>
      </div>
      <!--Account options -->
      <div class="lg:order-3">
        <UserBar :class="open && 'mt-4 flex flex-col'" @close-menu="closeMenu"></UserBar>
      </div>
    </nav>
  </div>
</template>

<script>
import UserBar from "./UserBar";
import Hamburger from "./icons/Hamburger.vue";

export default {
  name: "HeaderNav",

  components: {
    UserBar,
    Hamburger,
  },
  data: () => ({
    open: false,
    navigation: [
      {
        title: "Home",
        route: "/",
      },
      {
        title: "Flip",
        route: "/flip",
      },
      {
        title: "Hold",
        route: "/hold",
      },
      {
        title: "How it Works",
        route: "/models",
      },
    ],
  }),
  methods: {
    toggle() {
      this.open = !this.open;
    },
    closeMenu() {
      this.open = false;
    },
  },
};
</script>
